<div class='modal-header' [ngSwitch]='dialogMode' (click)='$event.stopPropagation()'>
  <ng-container *ngSwitchCase='"CREATE"'>
    <h4 class='modal-title'>{{ "TITLE.NEW_TREATMENT_" + treatmentType | translate }}</h4>
  </ng-container>

  <ng-container *ngSwitchCase='"DUPLICATE"'>
    <div class="d-flex flex-column">
      <h4 class='modal-title'>{{ "LABELS.DUPLICATE" | translate }}</h4>
      <span class="text-muted fst-italic small" *ngIf="duplicateTreatmentPayload?.payload?.name">
        {{ duplicateTreatmentPayload?.payload?.name }}
      </span>
    </div>
  </ng-container>
</div>

<div class='modal-body'
     [class.modal-body--create]="dialogMode === 'CREATE'"
     [class.modal-body--duplicate]="dialogMode === 'DUPLICATE'"
     (click)='$event.stopPropagation()'>
  <ng-container *ngIf='formGroup && !loading && !createFailed'>
    <form [formGroup]='formGroup'>
      <div class='form-group' *ngIf='checkUsedField("name")'>
        <label class="form-label">{{ 'LABELS.NAME_FOR_TREATMENT_' + treatmentType | translate }}
          <span class='text-danger'>*</span>
        </label>
        <input type='text'
               autocomplete='off'
               formControlName='name'
               [maxLength]='128'
               class='form-control form-control-sm'
        >
      </div>

      <!--INTERNAL ID----------------------------------------------------------------->
      <pt-input-text-conditional-checkbox
        [label]="'LABELS.INTERNAL_ID' | translate"
        [checkboxLabel]="'LABELS.DEFAULT_INTERNAL_ID' | translate"
        [cleanOnDisable]='true'
        [enableOnCheck]='false'
        [defaultCheckValue]='true'
        [controlName]="'internalId'"
        [activeValidatorsOnlyWhenEnabledInput]='true'
        formControlName='internalId'
        [validators]='[REQUIRED]'
        *ngIf='checkUsedField("internalId")'
      ></pt-input-text-conditional-checkbox>

      <div class='form-group' *ngIf='checkUsedField("description") && false'>
        <label class="form-label">{{ 'LABELS.DESCRIPTION' | translate }}</label>
        <textarea
          autocomplete='off'
          formControlName='description'
          class='form-control form-control-sm'
          [rows]='5'
          aria-describedby='ptWInputHelp'>
          </textarea>
      </div>
      <!--LEGAL ENTITY----------------------------------------------------------------->
      <ng-template #popContentLegalEntityContent class='p-0'>
        <pt-resource-navigation
          [title]="('TITLE.SELECT_LEGAL_ENTITY_FOR_TREATMENT_' + treatmentType) | translate"
          [data]='legalEntity'
          (clickClose)='popContentLegalEntity.close()'
          [selectedResourceId]='selectedLegalEntity?.id'
          (clickItem)='selectLegalEntity($event)'>
        </pt-resource-navigation>
      </ng-template>

      <div *ngIf='checkUsedField("legalEntityId")'>
        <label class="form-label">{{ ('LABELS.SELECT_LEGAL_ENTITY_FOR_TREATMENT_' + treatmentType) | translate }}
          <span class='text-danger'>*</span>
        </label>
        <div class='input-group input-group-sm' [class.mb-3]="dialogMode === 'CREATE'">
          <div class='input-group-text'>
            <pt-icon [key]="'legal-entity.svg'" [size]='14' [iconType]="'SVG'"></pt-icon>
          </div>
          <input type='text'
                 autocomplete='off'
                 formControlName='legalEntityId'
                 class='form-control form-control-sm form-readonly--custom'
                 aria-describedby="help"
                 [ngbPopover]='popContentLegalEntityContent'
                 [autoClose]="'outside'"
                 #popContentLegalEntity='ngbPopover'
                 triggers='manual' readonly placement='top' (click)='chooseLegalEntity()'
                 placeholder="{{('PLACEHOLDERS.SELECT_LEGAL_ENTITY_FOR_TREATMENT_' + treatmentType) | translate}}">

          <div class="mt-2" *ngIf="dialogMode === 'DUPLICATE'">
            <ng-container *ngIf="treatmentType === TreatmentType.HOLDER">
              <small class="form-text text-muted">
                {{ 'LABELS.DUPLICATE_HOLDER_INFO' | translate }}
              </small>
            </ng-container>

            <ng-container *ngIf="treatmentType === TreatmentType.RESPONSIBLE">
              <small class="form-text text-muted">
                {{ 'LABELS.DUPLICATE_RESPONSIBLE_INFO' | translate }}
              </small>
            </ng-container>

            <ng-container *ngIf="treatmentType === TreatmentType.SUB_RESPONSIBLE">
              <small class="form-text text-muted">
                {{ 'LABELS.DUPLICATE_SUB_RESPONSIBLE_INFO' | translate }}
              </small>
            </ng-container>

            <ng-container *ngIf="treatmentType === TreatmentType.PROJECT">
              <small class="form-text text-muted">
                {{ 'LABELS.DUPLICATE_PROJECT_INFO' | translate }}
              </small>
            </ng-container>
          </div>


          <button
            [disabled]="loading"
            type='button' class='btn-close tree-selector-clean font-10' aria-label='Close'
            (click)='cleanLegalEntity(); $event.stopPropagation()'>
            <!--            <span aria-hidden='true'>&times;</span>-->
          </button>
        </div>

      </div>

      <!--TREATMENT CATEGORIES----------------------------------------------------------------->
      <ng-template #popContentTreatmentCategoryContent class='p-0'>
        <pt-resource-navigation
          [title]="'TITLE.SELECT_TREATMENT_CATEGORY' | translate"
          [data]='treatmentCategories'
          [selectedResourceId]='selectedTreatmentCategory?.id'
          (clickClose)='popContentTreatmentCategory.close()'
          (clickItem)='selectTreatmentCategory($event)'>
        </pt-resource-navigation>
      </ng-template>

      <div class='tree-selector' *ngIf='checkUsedField("treatmentCategoryId")'>
        <label class="form-label">{{ 'LABELS.TREATMENT_CATEGORY' | translate }}</label>
        <div class='input-group input-group-sm mb-3'>
          <div class='input-group-text'>
            <pt-icon [key]="'treatment.svg'" [size]='14' [iconType]="'SVG'"></pt-icon>
          </div>
          <input type='text'
                 autocomplete='off'
                 formControlName='treatmentCategoryId'
                 class='form-control form-control-sm form-readonly--custom'
                 [ngbPopover]='popContentTreatmentCategoryContent'
                 [autoClose]="'outside'"
                 #popContentTreatmentCategory='ngbPopover'
                 triggers='manual'
                 readonly
                 placement='top'
                 (click)='chooseTreatmentCategory()'
                 placeholder="{{'PLACEHOLDERS.TREATMENT_CATEGORY' | translate}}">

          <button type='button'
                  [disabled]="loading"
                  class='btn-close tree-selector-clean font-10' aria-label='Close'
                  (click)='cleanTreatmentCategory(); $event.stopPropagation()'>
            <!--            <span aria-hidden='true'>&times;</span>-->
          </button>
        </div>
      </div>

      <!--DEPARTMENT ----------------------------------------------------------------->
      <ng-template #popContentDepartmentContent class='p-0'>
        <pt-resource-navigation
          [title]="'TITLE.SELECT_DEPARTMENT' | translate"
          [data]='departmentsNavData'
          [selectedResourceId]='selectedDepartment?.id'
          (clickClose)='popContentDepartment.close()'
          (clickItem)='selectDepartment($event)'>
        </pt-resource-navigation>
      </ng-template>

      <div class='tree-selector' *ngIf='checkUsedField("department")'>
        <label class="form-label">{{ 'LABELS.DEPARTMENT' | translate }}</label>
        <div class='input-group input-group-sm mb-3'>
          <div class='input-group-text'>
            <pt-icon [key]="'treatment.svg'" [size]='14' [iconType]="'SVG'"></pt-icon>
          </div>
          <input type='text'
                 autocomplete='off'
                 formControlName='departmentId'
                 class='form-control form-control-sm form-readonly--custom'
                 [ngbPopover]='popContentDepartmentContent'
                 [autoClose]="'outside'"
                 #popContentDepartment='ngbPopover'
                 triggers='manual'
                 placement='top'

                 readonly
                 (click)='chooseDepartment()'
                 placeholder="{{'PLACEHOLDERS.DEPARTMENT' | translate}}">

          <button type='button'
                  [disabled]="loading"
                  class='btn-close tree-selector-clean font-10' aria-label='Close'
                  (click)='cleanDepartment(); $event.stopPropagation()'>
            <!--            <span aria-hidden='true'>&times;</span>-->
          </button>
        </div>
      </div>

      <!--departmentProcessOwner ----------------------------------------------------------------->
      <ng-template #popContentProcessOwnerContent class='p-0'>
        <pt-resource-navigation
          [title]="'TITLE.SELECT_PROCESS_OWNER' | translate"
          [data]='departmentProcessOwner'
          [selectedResourceId]='selectedDepartmentProcessOwner?.id'
          (clickClose)='popContentProcessOwner.close()'
          (clickItem)='selectProcessOwner($event)'>
        </pt-resource-navigation>
      </ng-template>

      <div class='tree-selector' *ngIf='checkUsedField("processOwner")'>
        <label class="form-label">

          {{ 'LABELS.PROCESS_OWNER' | translate }}

          <pt-icon [key]='IconInfoCircle'
                   [size]='16'
                   class="d-inline-flex"
                   ngbTooltip="{{'TOOLTIP.PROCESS_OWNER_CREATE_DOCUMENT' | translate}}"
                   placement="bottom"
                   container='body'
          ></pt-icon>
        </label>
        <div class='input-group input-group-sm mb-3'>
          <div class='input-group-text'>
            <pt-icon [key]="'user.svg'" [size]='14' [iconType]="'SVG'"></pt-icon>
          </div>
          <input type='text'
                 autocomplete='off'
                 formControlName='processOwnerId'
                 class='form-control form-control-sm form-readonly--custom'
                 [ngbPopover]='popContentProcessOwnerContent'
                 [autoClose]="'outside'"
                 #popContentProcessOwner='ngbPopover'
                 triggers='manual'
                 readonly
                 placement='top'
                 (click)='chooseProcessOwner()'
                 placeholder="{{'PLACEHOLDERS.PROCESS_OWNER' | translate}}">

          <button type='button'
                  [disabled]="loading"
                  class='btn-close tree-selector-clean font-10' aria-label='Close'
                  (click)='cleanProcessOwner(); $event.stopPropagation()'>
          </button>
        </div>
      </div>

    </form>
  </ng-container>

  <ng-container *ngIf='loading'>
    <div class='loader-container'>
      <pt-loader></pt-loader>
    </div>
  </ng-container>


  <ng-container *ngIf='createFailed'>
    <div
      style="
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      ">
      <p>
        Il documento che si vuole creare non è stato configurato.
      </p>
      <p>
        {{ errorMessage }}
      </p>
      <p>
        Contattare il supporto
      </p>
      <a class='btn btn-sm btn-link mt-3 d-flex align-items-end'
         href='mailto:{{email}}?subject=[Primatoo] Request information about Management Workspace module'>
        <pt-icon
          [iconType]='IconType.IONIC_ICON'
          [key]='IconOpen'
          [size]='16'
        ></pt-icon>
        {{ "BUTTON.CONTACT" | translate }}
      </a>
    </div>

  </ng-container>
</div>

<div class='modal-footer' (click)='$event.stopPropagation()'>
  <button type='button'
          class='btn btn-primary btn-sm'
          [disabled]='formGroup?.invalid || loading || createFailed'
          [class.px-3]="dialogMode === 'CREATE'"
          (click)='confirm(); $event.stopPropagation()'>
    <ng-container [ngSwitch]='dialogMode'>
      <ng-container *ngSwitchCase='"CREATE"'>
        {{ 'BUTTON.CREATE' | translate }}
      </ng-container>
      <ng-container *ngSwitchCase='"DUPLICATE"'>
        {{ 'BUTTON.CONFIRM' | translate }}
      </ng-container>
    </ng-container>
  </button>

  <button ngbAutofocus type='button' class='btn btn-outline-secondary btn-sm'
          [disabled]="loading"
          (click)='activeModal.close(false); $event.stopPropagation()'>
    {{ 'BUTTON.CANCEL' | translate }}
  </button>
</div>

